import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Box } from '@mui/material';
import { setCurrentNavigationSectionAction } from 'actions';
import { FeaturePreviewContainer, FeaturePreviewEffects } from 'components/common/FeaturePreview';
import { ScrollStatusContext } from 'context';
import { useAppSelector, useHeaderHeight } from 'hooks';
import { ProforientationResultsPopupContainer } from 'portfolio3/features/proforientation';
import { YandexMetrika } from 'portfolio3/features/yandexMetrika';
import { useVariocubeExperiments } from 'portfolio3/features/yandexMetrika/hooks/useVariocubeExperiments';
import { configSelector } from 'selectors';
import { getCurrentPortfolioSectionId } from 'utils';

import { rootStyles } from './styles';

const MainContainer: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const config = useAppSelector(configSelector);
  const { currentNavigationSection } = useAppSelector((state) => state.navigationSection);
  const [isContainerScrolled, setContainerScrolled] = useState(false);

  const showProforientation = config && config.HIDE_PROFESSION_PROFORIENTATION !== true;
  const headerHeight = useHeaderHeight();
  useVariocubeExperiments();

  useEffect(() => {
    const handleScroll = () => {
      const currentSection = getCurrentPortfolioSectionId(headerHeight);
      const { scrollTop } = document.documentElement;

      if (currentSection !== currentNavigationSection) {
        dispatch(setCurrentNavigationSectionAction(currentSection));
      }

      if (scrollTop > 0 && !isContainerScrolled) {
        setContainerScrolled(true);
      } else if (scrollTop <= 0 && isContainerScrolled) {
        setContainerScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <ScrollStatusContext.Provider
      value={{
        isContainerScrolled,
      }}
    >
      <FeaturePreviewContainer />
      <FeaturePreviewEffects />
      <YandexMetrika />
      {showProforientation && <ProforientationResultsPopupContainer />}
      <Box component="main" sx={rootStyles} className="main-container">
        {children}
      </Box>
    </ScrollStatusContext.Provider>
  );
};

export default MainContainer;
